import { Building2, Landmark, ScrollText, ArrowRight } from "lucide-react";

const asks = [
  {
    id: 1,
    icon: Building2,
    label: "From the City of Baytown",
    title: "Council resolution as the workforce companion to the bond agenda",
    body:
      "Authorize CDBG public-service allocation as the human-capital companion to the 2025 $151M bond package, and issue a competitive RFP to three local Baytown agencies.",
    anchor: "#partnership",
    anchorLabel: "See the CDBG Ask",
  },
  {
    id: 2,
    icon: Landmark,
    label: "From the Federal Government",
    title: "HUD endorsement & technical assistance",
    body:
      "Public HUD endorsement of The Bridge Model, CDBG TA designation, and Opportunity-Zone coordination from Secretary Turner's office — positioning Baytown as the national showcase deployment.",
    anchor: "#federal",
    anchorLabel: "See the Federal Strategy",
  },
  {
    id: 3,
    icon: ScrollText,
    label: "From Community Partners",
    title: "Letters of support & referral commitments",
    body:
      "Lee College, Harris Health, Workforce Solutions, Baytown Housing Authority, the Area Agency on Aging, and GCCISD as committed referral and handoff partners.",
    anchor: "#network",
    anchorLabel: "See the Referral Network",
  },
];

export default function ThreeAsks() {
  return (
    <section
      id="asks"
      data-testid="section-three-asks"
      className="bg-[#0A192F] text-[#F9F7F1] py-16 lg:py-20 relative overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 grain-overlay opacity-20" />
      <div
        aria-hidden
        className="absolute -top-24 -left-24 w-[400px] h-[400px] rounded-full bg-[#D4AF37]/10 blur-3xl"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-baseline">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#D4AF37]" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">
                The Asks at a Glance · 60-Second Read
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Three asks. <em className="italic text-[#D4AF37]">Three signatures.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 text-[#CBD5E1] leading-relaxed">
            <p>
              If you only have a minute, here is exactly what The Baytown Bridge
              needs to launch. Click any of the three to jump directly to the
              detailed section.
            </p>
          </div>
        </div>

        <ol className="grid md:grid-cols-3 gap-px bg-[#F9F7F1]/15 border border-[#F9F7F1]/15">
          {asks.map((a) => {
            const Icon = a.icon;
            return (
              <li
                key={a.id}
                data-testid={`three-ask-${a.id}`}
                className="bg-[#0A192F] p-6 lg:p-7 flex flex-col"
              >
                <div className="flex items-center justify-between mb-4">
                  <Icon className="h-6 w-6 text-[#D4AF37]" />
                  <span className="font-mono text-[10px] uppercase tracking-widest text-[#D4AF37]">
                    0{a.id}
                  </span>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8] mb-2">
                  {a.label}
                </div>
                <h3 className="font-display text-lg lg:text-xl text-[#F9F7F1] leading-snug mb-3">
                  {a.title}
                </h3>
                <p className="text-xs lg:text-sm text-[#CBD5E1] leading-relaxed flex-1 mb-5">
                  {a.body}
                </p>
                <a
                  href={a.anchor}
                  data-testid={`three-ask-anchor-${a.id}`}
                  className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-[#D4AF37] hover:text-[#F9F7F1] transition-colors mt-auto"
                >
                  {a.anchorLabel} <ArrowRight className="h-3 w-3" />
                </a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
